// Injects Aria Belle-style cart-drawer elements (urgency timer, free-shipping progress bar,
// per-line "Save £X" badge, checkout-button amount, payment-icons + reviews footer) that don't
// exist in this theme's native cart-drawer markup. Same anchoring pattern as pdp-badges.js:
// native Shopify cart functionality (quantity steppers, discount form, checkout button, dynamic
// checkout wallets) stays fully intact — this only adds/reflows visual elements around it.
(function () {
  var FREE_SHIPPING_THRESHOLD = 50; // £50, matches the PDP USP copy ("Free Shipping ... over £50")
  var RESERVED_MINUTES = 10;

  function formatMoney(amount) {
    return '£' + amount.toFixed(2);
  }

  function parseAmount(text) {
    return parseFloat(String(text).replace(/[^0-9.]/g, '')) || 0;
  }

  function cartSubtotal() {
    var el = document.querySelector('[data-cart-subtotal] bdi, .cart-totals__total-value bdi');
    return el ? parseAmount(el.textContent) : 0;
  }

  function cartItemCount() {
    // Sum the quantity inputs directly rather than trusting the header badge — the badge can
    // lag a render cycle behind the actual line items right after an add/update.
    var inputs = document.querySelectorAll('cart-drawer-component input[data-cart-quantity]');
    if (inputs.length === 0) return 0;
    var total = 0;
    inputs.forEach(function (i) {
      total += parseInt(i.value, 10) || 0;
    });
    return total;
  }

  // ---- urgency banner: "LIMITED STOCK! RESERVED: HH:MM!" (counts down from time of open) ----
  function startReservedTimer(el) {
    var deadline = Date.now() + RESERVED_MINUTES * 60 * 1000;
    function tick() {
      // el is created and populated before being inserted into the DOM (buildUrgencyBar()
      // returns the element, which the caller then inserts) — bailing out here on the first
      // tick because the element isn't in document.body YET left the countdown text blank
      // forever. Only bail once the element has been inserted at least once and then removed
      // (drawer closed / re-rendered), tracked via a flag instead of a live DOM containment
      // check on the very first call.
      if (el.dataset.pdpTimerMounted === 'true' && !document.body.contains(el)) return;
      el.dataset.pdpTimerMounted = 'true';
      var remaining = Math.max(0, deadline - Date.now());
      var mins = Math.floor(remaining / 60000);
      var secs = Math.floor((remaining % 60000) / 1000);
      el.textContent =
        'LIMITED STOCK! RESERVED: ' + String(mins).padStart(2, '0') + ':' + String(secs).padStart(2, '0') + '!';
      if (remaining > 0) setTimeout(tick, 1000);
    }
    tick();
  }

  function buildUrgencyBar() {
    var bar = document.createElement('div');
    bar.className = 'pdp-cart-urgency';
    bar.innerHTML = '<span></span>';
    startReservedTimer(bar.querySelector('span'));
    return bar;
  }

  // ---- bundle-discount progress bar (replaces the free-shipping bar, 29-09 — Finn wants the
  // same slider mechanic communicating the quantity-discount tiers instead: 2=-10%, 3=-15%,
  // 4+=-20%, matching the Bundle & Save box on the PDP and the automatic Shopify discounts).
  // Pattern copied from a competitor reference (verazzio.com): text above the bar always names
  // the NEXT unreached tier ("Add 1 more item and save 15%"), the bar fills up to the last
  // reached checkpoint, and that checkpoint dot is enlarged/highlighted once reached. ----
  var DISCOUNT_TIERS = [
    { qty: 2, pct: 10 },
    { qty: 3, pct: 15 },
    { qty: 4, pct: 20 },
  ];
  function buildBundleDiscountBar() {
    var count = cartItemCount();
    var maxQty = DISCOUNT_TIERS[DISCOUNT_TIERS.length - 1].qty;
    var nextTier = DISCOUNT_TIERS.find(function (t) {
      return count < t.qty;
    });

    var wrap = document.createElement('div');
    wrap.className = 'pdp-cart-shipping-bar';

    var text;
    if (nextTier) {
      var needed = nextTier.qty - count;
      text = 'Add ' + needed + ' more item' + (needed > 1 ? 's' : '') + ' and save <b>' + nextTier.pct + '%</b>';
    } else {
      text = "You've unlocked the maximum discount — <b>" + DISCOUNT_TIERS[DISCOUNT_TIERS.length - 1].pct + '% off!</b>';
    }

    // Fill position: 0% at count=1 (no tier reached yet), 100% once count >= the last tier's qty.
    var fillPct = Math.min(100, Math.max(0, ((count - 1) / (maxQty - 1)) * 100));

    // Find the current tier (the last one reached) — that's the only checkpoint that gets the
    // sale-tag icon inside it, matching the reference (verazzio.com): unreached checkpoints are
    // plain dots sitting ON the track line, the reached one is enlarged with an icon inside.
    var currentTierIndex = -1;
    DISCOUNT_TIERS.forEach(function (t, i) {
      if (count >= t.qty) currentTierIndex = i;
    });

    var SALE_TAG_ICON =
      '<svg fill="currentColor" viewBox="0 -960 960 960" width="10" height="10"><path d="M503-104q-24 24-57 24t-57-24L103-390q-23-23-23-56.5t23-56.5l352-353q11-11 26-17.5t32-6.5h286q33 0 56.5 23.5T879-800v286q0 17-6.5 32T855-456L503-104Zm196-536q25 0 42.5-17.5T759-700q0-25-17.5-42.5T699-760q-25 0-42.5 17.5T639-700q0 25 17.5 42.5T699-640ZM446-160l353-354v-286H513L160-446l286 286Zm353-640Z"/></svg>';

    var checkpoints = DISCOUNT_TIERS.map(function (t, i) {
      var reached = i <= currentTierIndex;
      var isCurrent = i === currentTierIndex;
      var posPct = ((t.qty - 1) / (maxQty - 1)) * 100;
      return (
        '<div class="pdp-cart-discount-bar__checkpoint' +
        (reached ? ' pdp-cart-discount-bar__checkpoint--reached' : '') +
        '" style="left:' + posPct + '%">' +
        '<span class="pdp-cart-discount-bar__dot">' + (isCurrent ? SALE_TAG_ICON : '') + '</span>' +
        '<span class="pdp-cart-discount-bar__label">-' + t.pct + '%</span>' +
        '</div>'
      );
    }).join('');

    wrap.innerHTML =
      '<p class="pdp-cart-shipping-bar__text">' + text + '</p>' +
      '<div class="pdp-cart-discount-bar__track">' +
      '<div class="pdp-cart-discount-bar__fill" style="width:' + fillPct + '%"></div>' +
      checkpoints +
      '</div>';
    return wrap;
  }

  // ---- strip the trailing ", " the theme adds between variant options for its inline layout
  // (cart-products.liquid appends ",&nbsp;" after every option but the last one) — now that each
  // option shows on its own line via CSS, that trailing comma reads oddly after the value ----
  function cleanVariantSeparators(root) {
    root.querySelectorAll('.cart-items__variant dd').forEach(function (dd) {
      if (dd.dataset.pdpCartCleaned) return;
      dd.textContent = dd.textContent.replace(/,\s*$/, '').trim();
      dd.dataset.pdpCartCleaned = 'true';
    });
  }

  // ---- per-line "(Save £X)" green text, appended after the compare-at price ----
  function addSaveBadges(root) {
    root.querySelectorAll('.cart-items__unit-price-wrapper').forEach(function (wrap) {
      if (wrap.querySelector('.pdp-cart-save')) return;
      var sale = wrap.querySelector('span > bdi');
      var compare = wrap.querySelector('.compare-at-price bdi');
      if (!sale || !compare) return;
      var saleAmt = parseAmount(sale.textContent);
      var compareAmt = parseAmount(compare.textContent);
      if (!saleAmt || !compareAmt || compareAmt <= saleAmt) return;
      var save = document.createElement('span');
      save.className = 'pdp-cart-save';
      save.textContent = '(Save ' + formatMoney(compareAmt - saleAmt) + ')';
      wrap.appendChild(save);
    });
  }

  // ---- checkout button: show the cart total inside the button label ----
  function updateCheckoutAmount(root) {
    var btn = root.querySelector('#checkout, .cart__checkout-button');
    if (!btn) return;
    var span = btn.querySelector('.button-text') || btn.querySelector('span');
    var totalText = document.querySelector('[data-cart-subtotal] bdi');
    if (!span || !totalText) return;
    var amount = totalText.textContent.replace(/\s*GBP\s*/, '').trim();
    if (span.dataset.pdpCartAmount === amount) return; // already up to date, avoid re-triggering the observer
    var base = (span.textContent || 'Check out').replace(/\s*[•·]\s*£[\d.,]+\s*$/, '').trim();
    span.textContent = base + ' • ' + amount;
    span.dataset.pdpCartAmount = amount;
  }

  // ---- payment icons + reviews line under the checkout button ----
  // Real brand SVGs rendered server-side via Shopify's own payment_type_svg_tag filter
  // (window.PDP_CART_PAYMENT_ICONS_HTML, set in theme.liquid) — reflects whichever payment
  // methods are actually enabled on this shop, same source Shopify itself uses at checkout.
  function buildPaymentFooter() {
    var wrap = document.createElement('div');
    wrap.className = 'pdp-cart-payment-footer';
    var icons = window.PDP_CART_PAYMENT_ICONS_HTML || '';
    wrap.innerHTML =
      '<div class="pdp-cart-payment-footer__icons">' + icons + '</div>' +
      '<div class="pdp-cart-payment-footer__reviews">' +
      '<span class="pdp-cart-payment-footer__stars">★★★★★</span>' +
      '<span>Over <b>75,000+</b> satisfied customers</span>' +
      '</div>';
    return wrap;
  }

  function inject() {
    var summary = document.querySelector('.cart-drawer__summary, cart-drawer-component .cart-summary');
    var itemsWrap = document.querySelector('.cart-drawer__content, .cart-drawer__items');
    var header = document.querySelector('.theme-drawer__header');
    if (!header || !itemsWrap) return; // empty cart, or drawer not open yet

    if (!document.querySelector('.pdp-cart-urgency')) {
      header.insertAdjacentElement('afterend', buildUrgencyBar());
    }
    var urgencyEl = document.querySelector('.pdp-cart-urgency');
    // The discount bar's text/fill/checkpoints depend on the live item count, so replace it
    // on every inject() run (unlike the urgency timer, which only needs to exist once) — the
    // quantity can change without a full drawer re-render (+/- steppers on the line item).
    var existingBar = document.querySelector('.pdp-cart-shipping-bar');
    if (existingBar) existingBar.remove();
    if (urgencyEl) {
      urgencyEl.insertAdjacentElement('afterend', buildBundleDiscountBar());
    }

    cleanVariantSeparators(document);
    addSaveBadges(document);
    updateCheckoutAmount(document);

    if (summary && !summary.querySelector('.pdp-cart-payment-footer')) {
      summary.appendChild(buildPaymentFooter());
    }
  }

  function observe() {
    var target = document.querySelector('cart-drawer-component') || document.body;
    var scheduled = false;
    var mo = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        inject();
      }, 50);
    });
    mo.observe(target, { childList: true, subtree: true });
    inject();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
})();
